import { Route, Routes, useLocation } from "react-router-dom";

import React, { useEffect, Suspense } from "react";
import RegistrationCompleted from "../../Pages/education/RegistrationCompleted";
import BlogDetails from "../../Pages/blogs/BlogDetails";
const TutionRegistrations = React.lazy(() => import("../../Pages/admin_page/education/TutionRegistrations"));
const Education = React.lazy(() => import("../../Pages/education/Education"));
const TutionRegistrationDetails = React.lazy(() => import("../../Pages/education/TutionRegistrationDetails"));
const BlogsHome = React.lazy(() => import("../../Pages/blogs/BlogsHome"));
const Home = React.lazy(() => import("../../Pages/home/Home"));
const AboutUsPage = React.lazy(() => import("../../Pages/about_us/AboutUsPage"));
const ContactUs = React.lazy(() => import("../../Pages/contact_us/ContactUs"));
const Services = React.lazy(() => import("../../Pages/services/Services"));
const OnlineTraining = React.lazy(() => import("../../Pages/services/OnlineTraining"));
const PublicSector = React.lazy(() => import("../../Pages/services/PublicSector"));
const ItConsulting = React.lazy(() => import("../../Pages/services/ItConsulting"));
const EnterprisePartners = React.lazy(() => import("../../Pages/services/EnterprisePartners"));
const ResearchAnalytics = React.lazy(() => import("../../Pages/services/ResearchAnalytics"));
const SoftwareServices = React.lazy(() => import("../../Pages/services/SoftwareServices"));
const AiSolutions = React.lazy(() => import("../../Pages/services/AiSolutions"));
const TermsConditions = React.lazy(() => import("../../Pages/terms/TermsConditions"));
const AiHubPage = React.lazy(() => import("../../Pages/ai_hub/AiHubPage"));
const AiChatPage = React.lazy(() => import("../../Pages/ai_chat/AiChatPage"));
const LushaiAnaytics = React.lazy(() => import("../../Pages/lushai_analytics/LushaiAnaytics"));
const MizoYoutube = React.lazy(() => import("../../Pages/lushai_analytics/MizoYoutube"));
const Internship = React.lazy(() => import("../../Pages/careers/Internship"));
const Blogs = React.lazy(() => import("../../Pages/admin_page/blogs/Blogs"));
const InternApplications = React.lazy(() => import("../../Pages/admin_page/careers/InternApplications"));
const CareerOpenings = React.lazy(() => import("../../Pages/admin_page/careers/CareerOpenings"));
const JobApplications = React.lazy(() => import("../../Pages/admin_page/careers/JobApplications"));
const VcElection = React.lazy(() => import("../../Pages/lushai_analytics/VcElection"));
const VcElection2023vs2025 = React.lazy(() => import("../../Pages/lushai_analytics/VcElection2023vs2025"));
const AdminIndex = React.lazy(() => import("../../Pages/admin_page/AdminIndex"));
const CareersIndex = React.lazy(() => import("../../Pages/careers/CareersIndex"));
const NewBlog = React.lazy(() => import("../../Pages/admin_page/blogs/NewBlog"));


export default function AppRouter() {

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.fbq && window.fbq('track', 'PageView');
  }, [pathname])


  return (
    <Suspense fallback={<p>Loading route</p>}>
      <Routes>
        <Route
          exact
          strict
          path="/"
          element={<Home />}
        />
        <Route
          exact
          strict
          path="/contact"
          element={<ContactUs />}
        />
        <Route
          exact
          strict
          path="/services"
          element={<Services />}
        />
        <Route
          exact
          strict
          path="/services/online-training"
          element={<OnlineTraining />}
        />
        <Route
          exact
          strict
          path="/services/public-sector"
          element={<PublicSector />}
        />
        <Route
          exact
          strict
          path="/services/it-consulting"
          element={<ItConsulting />}
        />
        <Route
          exact
          strict
          path="/services/enterprise-partners"
          element={<EnterprisePartners />}
        />
        <Route
          exact
          strict
          path="/services/research-analytics"
          element={<ResearchAnalytics />}
        />
        <Route
          exact
          strict
          path="/services/software-services"
          element={<SoftwareServices />}
        />
        <Route
          exact
          strict
          path="/services/ai-solutions"
          element={<AiSolutions />}
        />
        <Route
          exact
          strict
          path="/terms"
          element={<TermsConditions />}
        />
        <Route
          exact
          strict
          path="/careers"
          element={<CareersIndex />}
        />
        <Route
          exact
          strict
          path="/careers/apply-internship"
          element={<Internship />}
        />
        <Route
          exact
          strict
          path="/admin/intership-applications"
          element={<InternApplications />}
        />
        <Route
          exact
          strict
          path="/admin/job-applications"
          element={<JobApplications />}
        />
        <Route
          exact
          strict
          path="/about-us"
          element={<AboutUsPage />}
        />
        <Route
          exact
          strict
          path="/blogs"
          element={<BlogsHome />}
        />
        <Route
          exact
          strict
          path="/blogs/:slug"
          element={<BlogDetails />}
        />

        <Route
          exact
          strict
          path="/education"
          element={<Education />}
        />

        <Route
          exact
          strict
          path="/education/registration/registration-completed"
          element={<RegistrationCompleted />}
        />

        <Route
          exact
          strict
          path="/education/registration-details/:reg_id"
          element={<TutionRegistrationDetails />}
        />

        <Route
          exact
          strict
          path="/ai-hub"
          element={<AiHubPage />}
        />
        <Route
          exact
          strict
          path="/ai-chat"
          element={<AiChatPage />}
        />
        <Route
          exact
          strict
          path="/lushai-analytics"
          element={<LushaiAnaytics />}
        />
        <Route
          exact
          strict
          path="/lushai-analytics/youtube-analytics"
          element={<MizoYoutube />}
        />
        <Route
          exact
          strict
          path="/lushai-analytics/vc-election-2025"
          element={<VcElection />}
        />
        <Route
          exact
          strict
          path="/lushai-analytics/vc-election-2023-vs-2025"
          element={<VcElection2023vs2025 />}
        />
        <Route
          exact
          strict
          path="/admin"
          element={<AdminIndex />}
        />
        <Route
          exact
          strict
          path="/admin/manage-career-openings"
          element={<CareerOpenings />}
        />
        <Route
          exact
          strict
          path="/admin/blogs"
          element={<Blogs />}
        />
        <Route
          exact
          strict
          path="/admin/blogs/post"
          element={<NewBlog />}
        />

        <Route
          exact
          strict
          path="/admin/education/tution-registrations"
          element={<TutionRegistrations />}
        />

      </Routes>
    </Suspense>
  )
}